import React, { FC, useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormControl, FormHelperText } from '@mui/material';
import styled from '@mui/system/styled';
import { isEmpty } from 'lodash';
import './globalCSelect.css';
import CTypography from 'components/CTypography';

export const MUISelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'grayColor',
})(({ theme, grayColor }) => ({
  '& .MuiSelect-select': {
    fontSize: '13px',
    padding: '8px 14px 9px',
    backgroundColor: grayColor ? '#F2F5F7' : '#fffff',
  },
  '& legend': {
    display: 'none',
  },
  '& fieldset': {
    top: 0,
  },
}));

interface ICSelect {
  name: string;
  value: string;
  options: {
    label: string;
    value: string;
  };
  size?: string;
  variant?: string;
  onChange: any;
  error: string;
  required: boolean;
  fieldProps: any;
  width?: number | string;
  placeholder?: string;
}

const CSelect: FC<any> = ({
  name,
  value,
  options,
  onChange,
  size = 'small',
  variant = 'outlined',
  error,
  required,
  fieldProps,
  width = '100%',
  placeholder,
  grayColor,
  itemProps = {
    style: { display: 'block', whiteSpace: 'inherit' },
  },
}) => {
  return (
    <FormControl
      size={size}
      variant={variant}
      error={!isEmpty(error)}
      required={required}
      sx={{ minWidth: width }}
    >
      <MUISelect
        name={name}
        value={value}
        size={size}
        onChange={onChange}
        autoComplete="off"
        {...fieldProps}
        displayEmpty
        grayColor={grayColor}
      >
        <MenuItem disabled value="">
          <em>{placeholder}</em>
        </MenuItem>

        {options.map((option) => (
          <MenuItem key={option.id} value={option.value} {...itemProps}>
            <CTypography
              style={{
                fontSize: 14,
                fontWeight: 600,
                lineHeight: '22px',
                letterSpacing: '0.1px',
              }}
            >
              {option.label}
            </CTypography>
            <CTypography
              style={{
                fontSize: 12,
                fontWeight: 400,
                lineHeight: '19.92px',
                letterSpacing: '0.4px',
              }}
            >
              {option?.subTitle}
            </CTypography>
          </MenuItem>
        ))}
      </MUISelect>
      {!isEmpty(error) && (
        <FormHelperText style={{ fontWeight: 700 }}>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CSelect;
